// This is the id of the root element for containing modals
// Make sure it matches the id in  @puzzle/ui/src/lib/constants until we move to the new pages router in Next.js
export const MODAL_ROOT_ID = "modal-root";
